import TextWithDuration from '../../../common/HelpText';

const LockedText = ({ text, time, textWithDurationProps }) => (
  <TextWithDuration
    textWithDurationProps={textWithDurationProps}
    text={text}
    time={time}
    timeFormat="hh:mm:ss"
    type="error"
  />
);

export default LockedText;
